// extracted by mini-css-extract-plugin
module.exports = {"stickyReview":"FormPc_stickyReview__2vZzB"};